import { ReactElement } from 'react'
import useTranslation from 'next-translate/useTranslation'
import { WithEmployerHeaderLayout } from '@/components/layouts'
import CustomHead from '@/components/molecules/CustomHead'
import PricingTemplate from '@/components/templates/Pricing'

export default function Pricing() {
  const { t } = useTranslation('forEmployers')
  return (
    <>
      <CustomHead
        metaData={{
          title: t('pricingTitle'),
          description: t('pricingDescription'),
        }}
      />
      <PricingTemplate />
    </>
  )
}

Pricing.getLayout = function getLayout(page: ReactElement) {
  return <WithEmployerHeaderLayout>{page}</WithEmployerHeaderLayout>
}
